import { render } from "./WorkAreasPage.vue?vue&type=template&id=2c939830"
import script from "./WorkAreasPage.vue?vue&type=script&lang=ts"
export * from "./WorkAreasPage.vue?vue&type=script&lang=ts"
script.render = render

export default script